import { authClient } from './auth-client.js';
import { el } from './dom.js';

export interface SessionInfo {
  id: string; name: string; email: string; role: 'user' | 'admin';
  nameHidden: boolean; ageHidden: boolean; photoHidden: boolean; cityHidden: boolean;
  consentVersion: string | null; consentTermsAt: string | null;
}

let cached: Promise<SessionInfo | null> | null = null;
/** Oturumu bir kez okur; sayfa içinde tekrar sorulmaz. */
export function currentSession(): Promise<SessionInfo | null> {
  cached ??= authClient.getSession().then(({ data }): SessionInfo | null => {
    if (!data) return null;
    const u = data.user as unknown as SessionInfo;
    return {
      id: u.id, name: u.name, email: u.email, role: u.role === 'admin' ? 'admin' : 'user',
      nameHidden: !!u.nameHidden, ageHidden: !!u.ageHidden, photoHidden: !!u.photoHidden, cityHidden: !!u.cityHidden,
      consentVersion: u.consentVersion ?? null, consentTermsAt: u.consentTermsAt ?? null,
    };
  }).catch((): SessionInfo | null => null);
  return cached;
}

/** Bekleyen talep sayısını menüdeki "Akrabalarım" bağlantısına rozet olarak ekler. */
async function showPendingBadge(link: HTMLElement): Promise<void> {
  try {
    const res = await fetch('/api/contact-requests/incoming', { credentials: 'same-origin' });
    if (!res.ok) return;
    const n = ((await res.json()) as { status: string }[]).filter((r) => r.status === 'pending').length;
    if (n > 0) link.append(el('span', { class: 'badge', title: 'Bekleyen iletişim talebi' }, [String(n)]));
  } catch { /* rozet gösterilemezse menü yine çalışır */ }
}

/** Üst menüyü oturuma göre kurar: giriş yoksa Giriş · Kayıt; varsa Akrabalarım · Ayarlar · [Moderasyon] · Çıkış.
 *  Soy listesi yükleme/güncelleme Ayarlar'daki açılır pencerededir; ayrı menü bağlantısı yoktur. */
export async function applySessionNav(): Promise<SessionInfo | null> {
  const nav = document.querySelector('header.site nav');
  const s = await currentSession();
  if (!nav) return s;
  if (s) {
    const out = el('a', { href: '#', id: 'logout' }, ['Çıkış']);
    out.addEventListener('click', async (e) => { e.preventDefault(); await authClient.signOut(); window.location.href = '/'; });
    // Talep ve mesajlaşma Akrabalarım satırlarında; ayrı "Talepler" bağlantısı yok.
    const rels = el('a', { href: '/akrabalarim.html' }, ['Akrabalarım']);
    void showPendingBadge(rels);
    const links: (Node | string)[] = [
      rels, ' · ',
      el('a', { href: '/ayarlar.html' }, ['Ayarlar']), ' · ',
    ];
    if (s.role === 'admin') links.push(el('a', { href: '/moderasyon.html' }, ['Moderasyon']), ' · ');
    nav.replaceChildren(...links, out);
  } else {
    nav.replaceChildren(el('a', { href: '/giris.html' }, ['Giriş']), ' · ', el('a', { href: '/kayit.html' }, ['Kayıt']));
  }
  return s;
}
